// extracted by mini-css-extract-plugin
export default {"-large":"YydXOUegVHTx0nrQigJK","closeButton":"k5tG25E2FD9KaJdnMugN","divider":"f5qXT9Ol1qOq5lEzZ75t"};